import { useState, type ReactNode } from 'react'
import { TopNav } from './TopNav'
import { Footer } from './Footer'
import { ForgeInstaller } from './ForgeInstaller'
import { Icon } from './Icon'

interface LayoutProps {
  children: ReactNode
  showInstaller?: boolean
}

export function Layout({ children, showInstaller = true }: LayoutProps) {
  const [mobileInstallerOpen, setMobileInstallerOpen] = useState(false)

  return (
    <div className="flex min-h-screen flex-col">
      <TopNav />

      <div className="relative flex flex-1">
        <main
          className={`flex-1 min-w-0 ${
            showInstaller ? 'lg:mr-[380px]' : ''
          }`}
        >
          {children}
        </main>

        {showInstaller && (
          <>
            {/* Desktop sidebar */}
            <aside className="fixed right-0 top-16 hidden h-[calc(100vh-64px)] w-[380px] flex-col border-l border-outline-variant bg-surface-container-low shadow-forge-sm lg:flex">
              <ForgeInstaller />
            </aside>

            {/* Mobile installer toggle */}
            <button
              type="button"
              onClick={() => setMobileInstallerOpen((v) => !v)}
              className="fixed bottom-4 right-4 z-40 flex h-12 items-center gap-2 rounded-full bg-primary px-4 font-label-sm text-label-sm font-bold text-on-primary shadow-forge-md lg:hidden"
            >
              <Icon name="construction" size={18} />
              Forge
            </button>

            {mobileInstallerOpen && (
              <div className="fixed inset-0 z-50 flex flex-col bg-surface lg:hidden">
                <div className="flex items-center justify-between border-b border-outline-variant px-4 py-3">
                  <span className="font-headline-md text-headline-md text-on-surface">Forge Installer</span>
                  <button
                    type="button"
                    onClick={() => setMobileInstallerOpen(false)}
                    className="flex h-10 w-10 items-center justify-center rounded text-on-surface-variant hover:text-primary"
                  >
                    <Icon name="close" />
                  </button>
                </div>
                <div className="flex-1 overflow-y-auto">
                  <ForgeInstaller />
                </div>
              </div>
            )}
          </>
        )}
      </div>

      <div className={showInstaller ? 'lg:mr-[380px]' : ''}>
        <Footer />
      </div>
    </div>
  )
}
